import React, { useEffect, useState } from 'react';
import Select from 'react-select';
import { useLocation } from 'react-router-dom';
import axios from 'axios';

const ViewPerformance = () => {
  const location = useLocation();
  const { batchId, playerId, selectedCenter, selectedMonth, selectedYear } = location.state;

  const [month, setMonth] = useState({ value: selectedMonth, label: getMonthLabel(selectedMonth) });
  const [year, setYear] = useState({ value: selectedYear, label: selectedYear });
  const token = localStorage.getItem('auth-token');
  const [attributes, setAttributes] = useState([]);
  const [parameters, setParameters] = useState([]);
  const [selectedAttribute, setSelectedAttribute] = useState(null);
  const [selectedParameter, setSelectedParameter] = useState(null);

  const monthOptions = Array.from({ length: 12 }, (_, i) => ({
    value: i + 1,
    label: new Date(0, i).toLocaleString('default', { month: 'long' }),
  }));

  const currentYear = new Date().getFullYear();
  const yearOptions = Array.from({ length: 10 }, (_, i) => ({
    value: currentYear - i,
    label: currentYear - i,
  }));

  function getMonthLabel(monthNumber) {
    return new Date(0, monthNumber - 1).toLocaleString('default', { month: 'long' });
  }

  useEffect(() => {
    const fetchPerformanceData = async () => {
      try {
        const response = await axios.get(
          `${process.env.REACT_APP_API_PERFORMANCE_VIEW}/${selectedCenter}/${playerId}/${batchId}?m=${month.value}&y=${year.value}`,
          {
            headers: {
              "Content-Type": "application/json",
              'Authorization': `Bearer ${token}`,
            },
          
          }
        );

        const result = response.data;
        if (result.success && result.data?.progress_attribute) {
          const attrOptions = result.data.progress_attribute.map(attr => ({
            value: attr.id,
            label: attr.name,
            parameters: attr.progressParameters.filter(p => p.status).map(p => ({
              value: p.id,
              label: p.name,
            })),
          }));

          setAttributes(attrOptions);

          if (attrOptions.length > 0) {
            setSelectedAttribute(attrOptions[0]);
            setParameters(attrOptions[0].parameters);
            if (attrOptions[0].parameters.length > 0) {
              setSelectedParameter(attrOptions[0].parameters[0]);
            }
          }
        }
      } catch (error) {
      }
    };

    if (month && year) fetchPerformanceData();
  }, [batchId, playerId, selectedCenter, month, year]);

  const handleAttributeChange = (attr) => {
    setSelectedAttribute(attr);
    setParameters(attr.parameters);
    setSelectedParameter(attr.parameters[0] || null);
  };

  return (
    <div className="enrollment-container">

      <div style={{ display: 'flex', gap: '20px', marginBottom: '24px' }}>
        <div style={{ width: '200px' }}>
          <label><strong>Month</strong></label>
          <Select
            options={monthOptions}
            value={month}
            onChange={setMonth}
            placeholder="Select Month"
          />
        </div>
        <div style={{ width: '200px' }}>
          <label><strong>Year</strong></label>
          <Select
            options={yearOptions}
            value={year}
            onChange={setYear}
            placeholder="Select Year"
          />
        </div>
        <div style={{ width: '200px' }}>
          <label><strong>Attribute</strong></label>
          <Select
            options={attributes}
            value={selectedAttribute}
            onChange={handleAttributeChange}
            placeholder="Select Attribute"
          />
        </div>
        <div style={{ width: '200px' }}>
          <label><strong>Parameter</strong></label>
          <Select
            options={parameters}
            value={selectedParameter}
            onChange={setSelectedParameter}
            placeholder="Select Parameter"
            isDisabled={!parameters.length}
          />
        </div>
      </div>

      {/* {selectedAttribute && selectedParameter && (
        <div>
          <h4>Selected:</h4>
          <p><strong>Month:</strong> {month.label}</p>
          <p><strong>Year:</strong> {year.label}</p>
          <p><strong>Attribute:</strong> {selectedAttribute.label}</p>
          <p><strong>Parameter:</strong> {selectedParameter.label}</p>
        </div>
      )} */}
    </div>
  );
};

export default ViewPerformance;
